"use client";

import { jsxs as a, jsx as r } from "react/jsx-runtime";
import "react";
import { classNames as N } from "../../utilities/index.js";
import c from "../Icon/index.js";
import { useToggle as _ } from "../hooks/useToggle/index.js";
const $ = _ref => {
    let {
      type: e,
      title: n,
      className: i,
      hideClose: d,
      children: t,
      onClose: m,
      iconClass: x,
      contentClass: u,
      titleClass: b,
      showCollapse: l = !1,
      ...h
    } = _ref;
    const {
        open: s,
        onToggleClick: g
      } = _(l),
      f = N({
        "sash-Alert relative rounded-sm flex p-2 border [&_a]:text-inherit [&_a]:underline hover:[&_a]:no-underline hover:[&_a]:text-inherit": !0,
        "border-red/50 bg-red-light": e === "error",
        "border-blue/50 bg-blue-light": e === "info",
        "border-green/50 bg-green-light": e === "success",
        [i]: i
      }),
      o = n && t,
      v = o ? "button" : "div";
    return /* @__PURE__ */a("div", {
      className: f,
      role: "alert",
      "aria-atomic": "true",
      ...h,
      children: [/* @__PURE__ */r("div", {
        className: `sash-AlertIcon mr-3 flex-none ${x || ""}`,
        children: /* @__PURE__ */r(c, {
          name: e === "error" ? "emergency_home" : e === "success" ? "check_circle" : "info",
          className: `block ${e === "error" ? "text-red" : e === "success" ? "text-green" : "text-blue"}`,
          fill: 1,
          weight: 700,
          size: 22
        })
      }), /* @__PURE__ */a("div", {
        className: `sash-AlertContent flex-1 space-y-3 [&_p:last-child]:m-0 ${u || ""}`,
        children: [n && /* @__PURE__ */a(v, {
          className: `sash-AlertTitle text-body-2 flex w-full select-text items-center text-left font-semibold text-gray-70 ${l ? "" : "md:cursor-text"} ${b || ""}`,
          onClick: t ? g : null,
          "aria-expanded": s,
          children: [n, o && /* @__PURE__ */r(c, {
            name: s ? "remove" : "add",
            className: `ml-auto block flex-none ${l ? "" : "md:hidden"}`
          })]
        }), t && /* @__PURE__ */r("div", {
          className: `text-body-2 text-gray-70 [&_ul]:m-0 [&_ul]:pl-5 ${o ? s ? "" : `hidden ${l ? "" : "md:block"}` : ""}`,
          "aria-hidden": !s,
          children: t
        })]
      }), !o && !d && /* @__PURE__ */r("div", {
        className: "sash-AlertClose ml-2 mt-1 flex-none",
        children: /* @__PURE__ */r("button", {
          className: "right-4 flex h-4 w-4 cursor-pointer items-center justify-center border-0 bg-transparent text-2xl/none font-light text-gray-70 hover:text-black",
          "aria-label": "Close",
          onClick: m,
          children: "×"
        })
      })]
    });
  },
  j = $;
export { j as default };